import React from "react";
import { Mail } from "lucide-react";

/**
 * Einheitlicher Hinweis nach jedem E-Mail-Versand (Registrierung, Insider-Report,
 * Password-Reset, Partner-Anmeldung, Webinar-Bestätigung etc.).
 *
 * - Bittet den Empfänger, den Spam-Ordner zu prüfen, falls innerhalb von 2 Minuten
 *   keine Mail eintrifft.
 * - Empfiehlt, die Absenderadresse als Kontakt zu speichern, damit zukünftige
 *   Alphalane-Mails sicher im Posteingang landen.
 */
export const MailDeliveryHint = ({ className = "", testid = "mail-delivery-hint" }) => {
  const sender = "noreply@alphalane-tradingsystems.com";
  return (
    <div
      data-testid={testid}
      className={`mt-5 mx-auto max-w-md text-left rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 ${className}`}
    >
      <div className="flex items-start gap-2.5">
        <Mail className="h-4 w-4 mt-0.5 text-amber-600 shrink-0" />
        <div className="text-[13px] leading-relaxed text-amber-900">
          <strong className="font-semibold">Keine Mail in 2 Minuten?</strong> Bitte
          schau einmal im <strong>Spam-Ordner</strong> nach. Damit zukünftige
          Alphalane-Mails sicher im Posteingang landen, speichere am besten unsere
          Absenderadresse <code className="px-1 py-0.5 rounded bg-white/70 border border-amber-200 text-amber-900 text-[12px] font-mono">{sender}</code> als Kontakt ab.
        </div>
      </div>
    </div>
  );
};

export default MailDeliveryHint;
